import { render, staticRenderFns } from "./createShanghOrder.vue?vue&type=template&id=11b83e4f&scoped=true"
import script from "./createShanghOrder.vue?vue&type=script&lang=js"
export * from "./createShanghOrder.vue?vue&type=script&lang=js"
import style0 from "./createShanghOrder.vue?vue&type=style&index=0&id=11b83e4f&prod&scoped=true&lang=css"
import style1 from "./createShanghOrder.vue?vue&type=style&index=1&id=11b83e4f&prod&lang=css"
import style2 from "./createShanghOrder.vue?vue&type=style&index=2&id=11b83e4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b83e4f",
  null
  
)

export default component.exports